import { render, staticRenderFns } from "./SearchOrderInput.vue?vue&type=template&id=20fbe041&"
import script from "./SearchOrderInput.vue?vue&type=script&lang=js&"
export * from "./SearchOrderInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports